import { c as _c } from "react/compiler-runtime";
import type { Scheme } from '@personly/libs-types';
import Picture from '@/components/picture';
import { SrcSet } from '@/libs/srcSets';
const makeSrcSet = (scheme: Scheme, height: number, alt: string): SrcSet => {
  const width = 175 / 152 * height;
  const fileName = `astateful-logo-${scheme.id.toLowerCase()}.svg`;
  const url = `/images/brands/${fileName}`;
  return {
    url,
    width,
    height,
    alt
  };
};
const makeSrcSets = (schemes: Array<Scheme>, height: number, alt: string) => schemes.filter(scheme => scheme.flags.browser).reduce((acc, scheme) => ({
  ...acc,
  [scheme.id]: makeSrcSet(scheme, height, alt)
}), {});
interface Props {
  alt: string;
  schemes: Array<Scheme>;
  height?: number;
}
const BrandJumbotron = t0 => {
  const $ = _c(6);
  const {
    alt,
    schemes,
    height: t1
  } = t0;
  const height = t1 === undefined ? 152 : t1;
  let t2;
  if ($[0] !== alt || $[1] !== height || $[2] !== schemes) {
    t2 = makeSrcSets(schemes, height, alt);
    $[0] = alt;
    $[1] = height;
    $[2] = schemes;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div className="flex flex-col justify-center items-center"><Picture srcSets={t2} /></div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default BrandJumbotron;